






































import { computed, defineComponent, onUnmounted, reactive, toRef, ref, onMounted } from '@vue/composition-api';
import MyLoadingIcon from '@/renderer/views/desktop/FileManagement/Transmission/components/MyLoadingIcon.vue';
import RowItem from '@/renderer/views/desktop/FileManagement/Transmission/components/RowItem.vue';

import { Task } from '@/renderer/scripts/utils/TaskManager/types';
import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';

import taskDetail from './TaskDetail.vue';

interface ListContentProps {
  list: Task<FileInfo>[]; // 当前列表
  type: string; // 当前列表的类型： 上传/下载/已完成
}

export default defineComponent({
  props: {
    list: {
      required: true,
      type: Array,
      default: [],
    },
    type: {
      required: true,
      type: String,
      default: 'upload',
    },
  },
  components: { taskDetail, RowItem, MyLoadingIcon },
  setup(props, context) {
    const listData = toRef(props, 'list');
    const autoHeight = ref(705);
    const taskDetail = reactive({
      task: {},
      // 选中的任务
      show: false, // 任务详情弹窗展示
    });

    const runningData = computed(() => listData.value.filter((v: any) => v.status === 'running'));
    const allSpeed = computed(() =>
      runningData.value.reduce((prev: number, curr: any) => prev + Number(curr.speed), 0),
    );
    const runningFlag = computed(() => runningData.value.length && props.type !== 'finish');
    const methods = {
      onEventProxy(command: string, task: Task<FileInfo>) {
        context.emit('onAction', {
          command,
          task,
          actionType: props.type,
        });
      },
      onAction(event: { command: string; actionType: string; task: Task<FileInfo> }) {
        const { command, task } = event;
        if (command === 'openTask') {
          if (!task.isDir) return;
          taskDetail.show = true;
          task.sortListByStatus();
          taskDetail.task = task;
        }
        context.emit('onAction', {
          command,
          task,
          actionType: props.type,
        });
      },
      percentFunc(item: Task<FileInfo>) {
        if (item.getListLength() === 1) {
          return `${item.getItem(0).percent * 100}%`;
        }
        const tmp = item.progressText.split('/');
        return `${(Number(tmp[0]) / Number(tmp[1])) * 100}%`;
      },
      heightFit(size: { height: number }) {
        autoHeight.value = (size.height || document.body.clientHeight) - 95 - 115 - 20 - 64; // top header+tab bottom operation
      },
    };
    // pc 主要监听electron ipc事件，winResize备用
    ipc.on(IpcEvents.WINDOW_RESIZE, methods.heightFit);
    ipc.on(ipc.RENDERER_EVENTS_MAP.WIN_RESIZE, methods.heightFit);
    onMounted(() => {
      methods.heightFit({
        height: document.body.clientHeight,
      });
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.WIN_RESIZE, methods.heightFit);
    });
    return {
      taskDetail,
      allSpeed,
      autoHeight,
      runningFlag,
      ...methods,
    };
  },
});
